'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DnDContext = undefined;

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactDnd = require('react-dnd');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DnDContext = exports.DnDContext = function DnDContext() {
  return function (BaseComponent) {
    var Component = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(BaseComponent);
    return (0, _hoistNonReactStatics2.default)(Component, BaseComponent);
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/components/dnd/index.jsx
// module id = 80
// module chunks = 0